import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/packages/client/app/layouts/default.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/app/packages/client/app/layouts/login.vue").then(m => m.default || m)),
  register: defineAsyncComponent(() => import("/app/packages/client/app/layouts/register.vue").then(m => m.default || m)),
  user: defineAsyncComponent(() => import("/app/packages/client/app/layouts/user.vue").then(m => m.default || m))
}